import React, { useEffect } from 'react'
import { useState } from 'react'
import { Card } from 'react-bootstrap'
import { fetchButtons } from '../../../Api/Buttons/Buttons';
import { Button, Message } from '../../../Api/Buttons/models';
import { AdminPublicInfo } from '../../../Api/Admin/models';
import { GetCbuResponse } from '../../../Api/CBU/models';
import toast from 'react-hot-toast';
import { PaymentScale } from './PaymentScale/PaymentScale';

interface CopyPastesProps {
    fetchedData: GetCbuResponse | null;
    adminInfo: AdminPublicInfo | null;
}

export const CopyPastes = ({ fetchedData, adminInfo }: CopyPastesProps) => {

    // Buttons
    const [bienvenidaButtons, setBienvenidaButtons] = useState<Button[]>([])
    const [infoButtons, setInfoButtons] = useState<Button[]>([])
    const [premiosButtons, setPremiosButtons] = useState<Button[]>([])
    const [fichasButtons, setFichasButtons] = useState<Button[]>([])
    const [extrasButtons, setExtrasButtons] = useState<Button[]>([])

    const handleCopyMessage = (message: Message[]) => {
        const updatedMessages = message.map(m => {
            let updatedMessage = m.text
                .replaceAll('__CBU__', (fetchedData?.CBU || 'Consultar CBU'))
                .replaceAll('__ALIAS__', fetchedData?.alias || 'Consultar alias')
                .replaceAll('__TITULAR__', fetchedData?.titular || 'Consultar titular')
                .replaceAll('__HORA__', fetchedData?.hour_limit || 'Consultar ')
                .replaceAll('__LINK__', adminInfo?.pageLink || 'Consultar')
                .replaceAll('__PASSWORD__', adminInfo?.default_users_password ?? 'hola123')
                .replaceAll('__NOMBRE__', fetchedData?.nombre || '')
            return updatedMessage;
        });

        navigator.clipboard.writeText(updatedMessages[Math.floor(Math.random() * updatedMessages.length)]);
        toast.success('Mensaje copiado al portapapeles')
    };


    useEffect(() => {
        fetchButtons().then((res: Button[]) => {
            const bienvenidaButtons: Button[] = [];
            const infoButtons: Button[] = [];
            const premiosButtons: Button[] = [];
            const fichasButtons: Button[] = [];
            const extrasButtons: Button[] = [];

            res?.forEach((button: any) => {
                if (button.category === 'bienvenida') {
                    bienvenidaButtons.push(button);
                } else if (button.category === 'info') {
                    infoButtons.push(button);
                } else if (button.category === 'premios') {
                    premiosButtons.push(button);
                } else if (button.category === 'fichas') {
                    fichasButtons.push(button)
                } else if (button.category === 'extra') {
                    extrasButtons.push(button)
                }
            });

            setBienvenidaButtons(bienvenidaButtons);
            setInfoButtons(infoButtons);
            setPremiosButtons(premiosButtons);
            setFichasButtons(fichasButtons);
            setExtrasButtons(extrasButtons);
        });
    }, []);


    return (
        <div className='d-flex flex-column w-100'>
            {bienvenidaButtons.length > 0 &&
                <Card className='mb-2'>
                    <Card.Body>
                        <div className='my-0 mx-0' style={{ display: 'flex', alignItems: 'center' }}>
                            <span className='text-secondary mb-2' style={{ fontSize: '10px' }}>Mensajes de Bienvenida</span>
                        </div>
                        {
                            bienvenidaButtons.map((button, index) =>
                            (<>

                                <button
                                    key={index}
                                    title={button.Messages[0]?.text}
                                    onClick={() => handleCopyMessage(button.Messages)}
                                    className="btn btn-sm btn-copypastes my-1 py-0 m-1"
                                    type="submit">{button.name}
                                </button>

                            </>))
                        }
                    </Card.Body>
                </Card>
            }

            {infoButtons.length > 0 &&
                <Card className='mb-2'>
                    <Card.Body>
                        <div className='my-0 mx-0' style={{ display: 'flex', alignItems: 'center' }}>
                            <span className='text-secondary mb-2' style={{ fontSize: '10px' }}>Mensajes de Información</span>
                        </div>
                        {
                            infoButtons.map((button, index) =>
                            (<>

                                <button
                                    key={index}
                                    title={button.Messages[0]?.text}
                                    onClick={() => handleCopyMessage(button.Messages)}
                                    className="btn btn-sm btn-copypastes my-1 py-0 m-1"
                                    type="submit">{button.name}
                                </button>

                            </>))
                        }
                    </Card.Body>
                </Card>
            }


            {premiosButtons.length > 0 &&
                <Card className='mb-2'>
                    <Card.Body>
                        <div className='my-0 mx-0' style={{ display: 'flex', alignItems: 'center' }}>
                            <span className='text-secondary mb-2' style={{ fontSize: '10px' }}>Mensajes de Premios</span>
                        </div>
                        {
                            premiosButtons.map((button, index) =>
                            (<>

                                <button
                                    key={index}
                                    title={button.Messages[0]?.text}
                                    onClick={() => handleCopyMessage(button.Messages)}
                                    className="btn btn-sm btn-copypastes my-1 py-0 m-1"
                                    type="submit">{button.name}
                                </button>

                            </>))
                        }
                    </Card.Body>
                </Card>
            }

            {fichasButtons.length > 0 &&
                <Card className='mb-2'>
                    <Card.Body>
                        <div className='my-0 mx-0' style={{ display: 'flex', alignItems: 'center' }}>
                            <span className='text-secondary mb-2' style={{ fontSize: '10px' }}>Mensajes de Fichas</span>
                        </div>
                        {
                            fichasButtons.map((button, index) =>
                            (<>

                                <button
                                    key={index}
                                    title={button.Messages[0]?.text}
                                    onClick={() => handleCopyMessage(button.Messages)}
                                    className="btn btn-sm btn-copypastes my-1 py-0 m-1"
                                    type="submit">{button.name}
                                </button>

                            </>))
                        }
                    </Card.Body>
                </Card>
            }

            {extrasButtons.length > 0 &&
                <Card className='mb-2'>
                    <Card.Body>
                        <div className='my-0 mx-0' style={{ display: 'flex', alignItems: 'center' }}>
                            <span className='text-secondary mb-2' style={{ fontSize: '10px' }}>Mensajes Extras</span>
                        </div>
                        {
                            extrasButtons.map((button, index) =>
                            (<>

                                <button
                                    key={index}
                                    title={button.Messages[0]?.text}
                                    onClick={() => handleCopyMessage(button.Messages)}
                                    className="btn btn-sm btn-copypastes my-1 py-0 m-1"
                                    type="submit">{button.name}
                                </button>

                            </>))
                        }
                    </Card.Body>
                </Card>
            }

            <PaymentScale />
        </div>
    )
}

